import React, { useState, useEffect } from 'react';
import { 
  ChevronLeft, 
  ChevronRight, 
  Award, 
  Users, 
  MapPin, 
  Globe 
} from 'lucide-react';

const ImpactCarousel = () => {
  const [currentSlide, setCurrentSlide] = useState(0);

  const slides = [
    {
      highlight: "50 años",
      text: "de educación a distancia democratizando el acceso a la educación superior",
      icon: <Award size={48} className="text-[#febe10]" />
    },
    {
      highlight: "+35.000 estudiantes",
      text: "en programas de tecnología, grado y posgrado",
      icon: <Users size={48} className="text-[#febe10]" />
    },
    {
      highlight: "+90 centros nacionales",
      text: "demostrando una amplia cobertura en Ecuador",
      icon: <MapPin size={48} className="text-[#febe10]" />
    },
    {
      highlight: "3 centros internacionales",
      text: "en Madrid, Nueva York y Roma, acompañando a ecuatorianos en el mundo",
      icon: <Globe size={48} className="text-[#febe10]" />
    }
  ];

  // Transición automática cada 6 segundos (lenta y suave)
  useEffect(() => {
    const timer = setInterval(() => {
      setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
    }, 6000);
    return () => clearInterval(timer);
  }, [slides.length]);

  const nextSlide = () => setCurrentSlide((prev) => (prev === slides.length - 1 ? 0 : prev + 1));
  const prevSlide = () => setCurrentSlide((prev) => (prev === 0 ? slides.length - 1 : prev - 1));

  return (
    <div className="bg-white">
      <div className="max-w-5xl mx-auto ">
        
        {/* Contenedor Principal Azul con Rotación */}
        <div className="relative bg-[#004270] rounded-[4rem] shadow-2xl rotate-2 transition-transform hover:rotate-0 duration-1000 min-h-[450px] flex items-center justify-center overflow-hidden border-4 border-[#febe10]/10">
          
          {/* Número 50 decorativo de fondo */}
          <div className="absolute inset-0 flex items-center justify-center pointer-events-none">
            <span className="text-[25rem] font-black text-white/[0.03] leading-none select-none">50</span>
          </div>

          {/* Contenido del Carrusel */}
          <div className="relative z-10 w-full px-8 md:px-20 text-center flex flex-col items-center">
            
            {/* Espacio para el Icono Animado */}
            <div className="mb-8 animate-bounce duration-[3000ms]">
              {slides[currentSlide].icon}
            </div>
            
            <div className="relative w-full min-h-[200px] flex items-center justify-center">
              {slides.map((slide, index) => (
                <div
                  key={index}
                  className={`transition-all duration-[1500ms] absolute inset-0 flex flex-col items-center justify-center transform ${
                    index === currentSlide 
                      ? "opacity-100 translate-y-0 scale-100" 
                      : "opacity-0 -translate-y-12 scale-90 pointer-events-none"
                  }`}
                >
                  <span className="text-6xl md:text-6xl font-bold text-[#febe10] block mb-6 tracking-tighter">
                    {slide.highlight}
                  </span>
                  <p className="text-xl md:text-m font-light text-white leading-tight max-w-2xl ">
                    {slide.text}
                  </p>
                </div>
              ))}
            </div>

            {/* Controles y Navegación */}
            <div className="mt-12 flex items-center gap-8">
              <button 
                onClick={prevSlide}
                className="group p-3 rounded-full bg-white/5 border border-white/10 text-white hover:bg-[#febe10] hover:text-[#004270] transition-all"
              >
                <ChevronLeft size={24} />
              </button>

              {/* Indicadores de progreso */}
              <div className="flex gap-3">
                {slides.map((_, i) => (
                  <button 
                    key={i} 
                    onClick={() => setCurrentSlide(i)}
                    className={`h-1.5 rounded-full transition-all duration-700 ${
                      i === currentSlide ? "w-12 bg-[#febe10]" : "w-3 bg-white/20"
                    }`}
                  />
                ))}
              </div>

              <button 
                onClick={nextSlide}
                className="group p-3 rounded-full bg-white/5 border border-white/10 text-white hover:bg-[#febe10] hover:text-[#004270] transition-all"
              >
                <ChevronRight size={24} />
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ImpactCarousel;